import React from 'react';
import {
    Flex, IconButton, Heading, Spacer, Menu, MenuButton, MenuList, MenuItem, Avatar,
    HStack, Text, Button, Icon, useDisclosure
} from '@chakra-ui/react';
import { ChevronDownIcon, HamburgerIcon } from '@chakra-ui/icons';
import { useAuth } from '../../Contexts/AuthContext';
import { useLang } from '../../Hooks';
import { MdSettings, MdLogout, MdLock } from 'react-icons/md';
import LangSwitch from '../LangSwitch';
import ChangePasswordModal from './ChangePasswordModal';
import RenewModal from './RenewModal';

const Header = ({ onOpenSidebar, pageTitle }) => {

     const getButtonColor = () => {
        const currentHostname = typeof window !== 'undefined' ? window.location.hostname : '';
        if (currentHostname === 'client.tadweeen.com') {
            return {
                bg: '#F9A825',
                hoverBg: '#f57f17',
                text: 'white'
            };
        }
        return {
            bg: 'var(--btn-special-bg)',
            hoverBg: 'var(--btn-special-hover-bg)',
            text: 'var(--btn-special-text)'
        };
    };
      const buttonColors = getButtonColor();
    const { user, logout } = useAuth();
    const { lang, texts } = useLang();
    const { isOpen: isChangePasswordOpen, onOpen: onChangePasswordOpen, onClose: onChangePasswordClose } = useDisclosure();
    const { isOpen: isRenewOpen, onOpen: onRenewOpen, onClose: onRenewClose } = useDisclosure();

    const customerName = user?.CustomerName || 'User';
    const initials = customerName.split(' ').map(n => n[0]).join('').toUpperCase();

    return (
        <>
            <Flex
                as="header"
                align="center"
                justify="space-between"
                w="full"
                px={{ base: 4, md: 6 }}
                py={2}
                h="2.5rem"
                position="sticky"
                top="0"
                zIndex="banner"
                sx={{
                    bg: 'var(--header-bg)',
                    borderBottom: '1px solid var(--header-border-color)',
                    transition: 'background 0.3s ease-in-out, border-color 0.3s ease-in-out'
                }}
            >
                <Flex align="center">
                    <IconButton
                        aria-label="Open menu"
                        icon={<HamburgerIcon boxSize={6} />}
                        onClick={onOpenSidebar}
                        variant="ghost"
                        display={{ base: 'flex', md: 'none' }}
                        sx={{ color: 'var(--header-icon-color)' }}
                    />
                    <Heading size="md" display={{ base: 'none', md: 'block' }} fontWeight="medium" sx={{ color: 'var(--header-text-color)' }}>
                        {pageTitle}
                    </Heading>
                </Flex>

                <Heading
                  size="sm"
                  display={{ base: 'block', md: 'none' }}
                  fontWeight="medium"
                  position="absolute"
                  left="50%"
                  transform="translateX(-50%)"
                  sx={{ color: 'var(--header-text-color)' }}
                >
                    {pageTitle}
                </Heading>

                <Spacer />

                <HStack spacing={{ base: 1, md: 1 }}>
                     <Button 
                    onClick={onRenewOpen}
                    bg={buttonColors.bg}
                    color={buttonColors.text}
                    _hover={{ bg: buttonColors.hoverBg }}
                    size="sm"
                    height="32px"
                    px={4}
                >
                    {texts.header?.subscription || 'Subscription'}
                </Button>
                    <LangSwitch variant="dark" />
                    <Menu placement={lang === 'ar' ? "bottom-start" : "bottom-end"}>
                        <MenuButton
                            as={Button}
                            rounded={'full'}
                            variant={'link'}
                            cursor={'pointer'}
                            minW={0}
                            _hover={{ textDecoration: 'none' }}
                        >
                            <Flex align="center">
                                <Avatar
                                    size={'sm'}
                                    name={customerName}
                                    getInitials={() => initials}
                                    sx={{
                                        bg: 'var(--avatar-bg)',
                                        color: 'var(--avatar-text)'
                                    }}
                                />
                                <Text fontWeight="medium" mx={2} display={{ base: 'none', md: 'inline' }} sx={{ color: 'var(--header-text-color)' }}>
                                    {customerName.split(' ')[0]}
                                </Text>
                                <Icon as={ChevronDownIcon} sx={{ color: 'var(--header-icon-color)' }} />
                            </Flex>
                        </MenuButton>
                        <MenuList 
                            zIndex="popover" 
                            minW="180px"
                            sx={{
                                bg: 'var(--menu-bg)',
                                borderColor: 'var(--menu-border-color)',
                                color: 'var(--menu-item-text-color)'
                            }}
                        >
                            {/* <MenuItem 
                                icon={<Icon as={MdSettings} />}
                                sx={{ _hover: { bg: 'var(--menu-item-hover-bg)' } }}
                            >
                                {texts.header?.profile || "Profile"}
                            </MenuItem> */}
                            <MenuItem 
                                icon={<Icon as={MdLock} />} 
                                onClick={onChangePasswordOpen}
                                sx={{ _hover: { bg: 'var(--menu-item-hover-bg)' } }}
                            >
                                {texts.header?.changePassword || "Change Password"}
                            </MenuItem>
                            <MenuItem 
                                icon={<Icon as={MdLogout} />} 
                                onClick={logout}
                                sx={{ _hover: { bg: 'var(--menu-item-hover-bg)' } }}
                            >
                                {texts.sidebar?.signOut || "Sign Out"}
                            </MenuItem>
                        </MenuList>
                    </Menu>
                </HStack>
            </Flex>

            <ChangePasswordModal isOpen={isChangePasswordOpen} onClose={onChangePasswordClose} />
            <RenewModal isOpen={isRenewOpen} onClose={onRenewClose} />
        </>
    );
};

export default Header;